import { EnquiryDto } from '@careapp-group/ng-sdk';
import { createReducer, on } from '@ngrx/store';
import { CaEntityState } from '../../store/entity-state/entity-state';
import { CaEntityReducer } from '../../store/entity-state/entity-reducer';
import { BaseFilterType } from '../../store/entity-state/entity-actions-factory';
import { mergeReducers } from '../../store/entity-state/merge-reducers';
import { Enquiries } from './enquiries.actions';

export interface EnquiriesFilterType extends BaseFilterType {
  sortBy?: 'rating' | 'assignee' | 'lastUpdated' | 'created' | 'state';
  sortDirection?: 'ASC' | 'DESC';
}

export interface EnquiriesState extends CaEntityState<EnquiryDto> {
  unreadCount: number;
  activeChannelCid?: string;
}

export class EnquiriesReducer extends CaEntityReducer<EnquiryDto, EnquiriesFilterType> {
  assigneeReducer = createReducer(
    { ...this.initialState, unreadCount: 0, activeChannelCid: null },
    on(Enquiries.requestUpdateEnquiryAssignee, (state) => ({
      ...state,
      loadingAll: true,
    })),
    on(Enquiries.successUpdateEnquiryAssignee, (state, action) => ({
      ...state,
      entities: {
        ...state.entities,
        [action.channelId]: action.updatedEnquiry,
      },
      ids: Array.from(new Set([...state.ids, action.channelId])),
      loadingAll: false,
    })),
    on(Enquiries.failUpdateEnquiryAssignee, (state) => ({
      ...state,
      loadingAll: false,
    })),
    on(Enquiries.updateUnreadEnquiryCount, (state, action) => ({
      ...state,
      unreadCount: action.count,
    })),
    on(Enquiries.requestCreateEnquiry, (state) => ({
      ...state,
      loadingAll: true,
    })),
    on(Enquiries.failCreateEnquiry, (state) => ({
      ...state,
      loadingAll: false,
    })),
    on(Enquiries.successCreateEnquiry, (state, action) => ({
      ...state,
      ids: Array.from(new Set([...state.ids, action.enquiry.id])),
      entities: {
        ...state.entities,
        [action.enquiry.id]: action.enquiry,
      },
      loadingAll: false,
    })),
    on(Enquiries.requestRateEnquiry, (state) => ({
      ...state,
      loadingAll: true,
    })),
    on(Enquiries.successRateEnquiry, (state, action) => ({
      ...state,
      ids: Array.from(new Set([...state.ids, action.updatedEnquiry.id])),
      entities: {
        ...state.entities,
        [action.updatedEnquiry.id]: action.updatedEnquiry,
      },
      loadingAll: false,
    })),
    on(Enquiries.failRateEnquiry, (state) => ({
      ...state,
      loadingAll: false,
    })),
    on(Enquiries.setActiveEnquiryChannel, (state, action) => ({
      ...state,
      activeChannelCid: action.cid,
    })),
  );

  public reducer(state, action) {
    return this.combinedReducer(state, action);
  }

  public combinedReducer = mergeReducers(this.assigneeReducer, this.entityReducer);
}

export const state = new EnquiriesReducer(Enquiries);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
